import React, { FunctionComponent } from "react"
import { FormProvider, useForm } from "react-hook-form"
import { store } from "react-notifications-component"
import { Route, useHistory, useRouteMatch } from "react-router"
import { notificationOptions } from "../../../api/Definitions"
import { iNews } from "../../../definitions/News"
import { post } from "../../../store/data/actions"
import NewsHeader from "../Header"
import NewsDescription from "../inspector/Description"
import NewsOverview from "../inspector/Overview"
import NewsUploads from "../inspector/Uploads"

const CreateNews: FunctionComponent = () => {
  const history = useHistory()
  const match = useRouteMatch()
  const methods = useForm({ shouldUnregister: false })

  const onSubmit = (data: iNews) => {
    post<iNews>({ link: "/v2/create-news", data }).then((news) => {
      history.push("/news/" + news.url)
      store.addNotification({
        title: "Success!",
        message: "News successfully created!",
        type: "success",
        ...notificationOptions,
      })
    })
  }

  return (
    <FormProvider {...methods}>
      <NewsHeader
        submitDeleteText="Delete"
        title="Create News"
        submitText="Create"
        handleDelete={() => {
          console.log("Deleted!")
        }}
        handleSubmit={() => {
          methods.handleSubmit((data) => {
            onSubmit(data as iNews)
          })()
        }}
      />
      <div className="inspector">
        <form
          onSubmit={methods.handleSubmit((data) => {
            onSubmit(data as iNews)
          })}
          className="inspector-form"
        >
          <Route exact path={match.path}>
            <NewsOverview />
          </Route>
          <Route exact path={match.path + "/description"}>
            <NewsDescription />
          </Route>
          <Route exact path={match.path + "/manage-files"}>
            <NewsUploads />
          </Route>
          <button className="d-none" type="submit">
            Submit
          </button>
        </form>
      </div>
    </FormProvider>
  )
}

export default CreateNews
